// extracted by mini-css-extract-plugin
export var aircallIframe = "_k0-3";
export var fabContainer = "_k0-5";
export var fabRinging = "_k0-6";
export var loadingOverlay = "_k0-4";
export var pulse = "_k0-7";
export var widgetContent = "_k0-2";
export var widgetPanel = "_k0-0";
export var widgetPanelExpanded = "_k0-1";